/**
 * ht-flavor-picker.js
 * Happy Tails 味の配分ピッカー
 * - set:20  → モード（3種ミックス / 2種 / 1種）
 * - set:100 → 25個入り×4袋を配分
 * - set:200 → 25個入り×8袋を配分
 * 選択結果を明細プロパティ properties[味の内訳] に書き込み、
 * 合計が合わないうちは購入ボタンを無効化する。
 */
(function () {
  'use strict';

  var FLAVORS = ['モカ', 'スペシャル', 'イタリアン'];
  var FLAVOR_CODES = { 'モカ': 'M', 'スペシャル': 'S', 'イタリアン': 'I' };

  function initPicker(root) {
    if (root.dataset.htfpInit === '1') return;
    root.dataset.htfpInit = '1';

    var set = parseInt(root.getAttribute('data-ht-set'), 10) || 0;
    var bags = parseInt(root.getAttribute('data-ht-bags'), 10) || 0;
    var submitId = root.getAttribute('data-ht-submit');
    var propInput = root.querySelector('[data-htfp-prop]');
    var shippingLabelInput = root.querySelector('[data-htfp-shipping-label]');
    var statusEl = root.querySelector('[data-htfp-status]');
    var hintEl = root.querySelector('[data-htfp-hint]');

    function submitBtn() { return submitId ? document.getElementById(submitId) : null; }
    function setValid(valid) {
      var btn = submitBtn();
      if (btn) btn.disabled = !valid;
    }
    function setStatus(text, ok) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      statusEl.className = 'htfp__status ' + (ok ? 'htfp__status--ok' : 'htfp__status--ng');
    }
    function setHint(text) { if (hintEl) hintEl.textContent = text || ''; }

    if (set === 20) {
      initModeUI(root, propInput, shippingLabelInput, setValid, setStatus, setHint);
    } else {
      initStepperUI(root, bags, set, propInput, shippingLabelInput, setValid, setStatus, setHint);
    }
  }

  /* ── 20個：モード式 ─────────────────────────── */
  function initModeUI(root, propInput, shippingLabelInput, setValid, setStatus, setHint) {
    var modeBtns = root.querySelectorAll('[data-mode]');
    var flavorArea = root.querySelector('[data-htfp-flavors]');
    var mode = 'mix';
    var selected = []; // 'two'/'one' 用の選択済み味

    function render() {
      // モードボタンの見た目
      modeBtns.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-mode') === mode ? 'true' : 'false');
      });

      if (mode === 'mix') {
        flavorArea.hidden = true;
        flavorArea.innerHTML = '';
      } else {
        flavorArea.hidden = false;
        var max = mode === 'two' ? 2 : 1;
        setHint(''); // 重複案内は出さない（赤いステータスのみで案内）
        flavorArea.innerHTML = FLAVORS.map(function (f) {
          var on = selected.indexOf(f) !== -1;
          return '<button type="button" class="htfp__flavor-btn" data-flavor="' + f + '" aria-pressed="' + on + '">' +
            '<span class="htfp__check">' + (on ? '✓' : '') + '</span>' + f + 'ブレンド</button>';
        }).join('');
        flavorArea.querySelectorAll('[data-flavor]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var f = btn.getAttribute('data-flavor');
            var i = selected.indexOf(f);
            if (i !== -1) {
              selected.splice(i, 1);
            } else {
              if (selected.length >= max) selected.shift(); // 上限超えたら古いものを外す
              selected.push(f);
            }
            render();
          });
        });
      }
      update();
    }

    function update() {
      if (mode === 'mix') {
        propInput.value = '3種ミックス（おまかせ）';
        if (shippingLabelInput) shippingLabelInput.value = 'コーヒー20個（3種）';
        setStatus('3種ミックス（おまかせ）でお届けします', true);
        setHint('');
        setValid(true);
      } else if (mode === 'two') {
        if (selected.length === 2) {
          propInput.value = selected.map(function (f) { return f + '×10個'; }).join('・');
          if (shippingLabelInput) {
            var codes = selected.map(function (f) { return FLAVOR_CODES[f]; });
            shippingLabelInput.value = 'コーヒー20個（' + codes.join('&') + '）';
          }
          setStatus(selected.join('・') + ' を10個ずつ', true);
          setValid(true);
        } else {
          propInput.value = '';
          if (shippingLabelInput) shippingLabelInput.value = '';
          setStatus('あと' + (2 - selected.length) + '種類選んでください', false);
          setValid(false);
        }
      } else { // one
        if (selected.length === 1) {
          propInput.value = selected[0] + '×20個';
          if (shippingLabelInput) shippingLabelInput.value = 'コーヒー20個（' + FLAVOR_CODES[selected[0]] + 'のみ）';
          setStatus(selected[0] + ' を20個', true);
          setValid(true);
        } else {
          propInput.value = '';
          if (shippingLabelInput) shippingLabelInput.value = '';
          setStatus('1種類選んでください', false);
          setValid(false);
        }
      }
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-mode');
        selected = [];
        render();
      });
    });

    render(); // 初期：mix（有効）
  }

  /* ── 100/200個：袋ステッパー ─────────────────── */
  function initStepperUI(root, bags, set, propInput, shippingLabelInput, setValid, setStatus, setHint) {
    var area = root.querySelector('[data-htfp-steppers]');
    var counts = {};
    FLAVORS.forEach(function (f) { counts[f] = 0; });

    // 初期配分（合計 bags ぴったり・すぐ買える状態）
    var defaults = bags === 4 ? [2, 1, 1] : bags === 8 ? [3, 3, 2] : null;
    if (defaults) {
      FLAVORS.forEach(function (f, i) { counts[f] = defaults[i]; });
    }

    area.innerHTML = FLAVORS.map(function (f) {
      return '<div class="htfp__stepper" data-flavor="' + f + '">' +
        '<span class="htfp__stepper-name">' + f + 'ブレンド</span>' +
        '<span class="htfp__stepper-ctrl">' +
          '<button type="button" class="htfp__step-btn" data-dec aria-label="' + f + 'を減らす">−</button>' +
          '<span class="htfp__count" data-count>0</span>' +
          '<button type="button" class="htfp__step-btn" data-inc aria-label="' + f + 'を増やす">＋</button>' +
        '</span>' +
      '</div>';
    }).join('');

    function total() {
      return FLAVORS.reduce(function (s, f) { return s + counts[f]; }, 0);
    }

    function render() {
      FLAVORS.forEach(function (f) {
        var row = area.querySelector('[data-flavor="' + f + '"]');
        row.querySelector('[data-count]').textContent = counts[f];
        var t = total();
        row.querySelector('[data-inc]').disabled = t >= bags;
        row.querySelector('[data-dec]').disabled = counts[f] <= 0;
      });
      update();
    }

    function update() {
      var t = total();
      if (t === bags) {
        var parts = FLAVORS.filter(function (f) { return counts[f] > 0; })
          .map(function (f) { return f + '×' + counts[f] + '袋(' + (counts[f] * 25) + '個)'; });
        propInput.value = parts.join('・');
        if (shippingLabelInput) {
          var codes = FLAVORS.filter(function (f) { return counts[f] > 0; })
            .map(function (f) { return FLAVOR_CODES[f] + counts[f]; });
          shippingLabelInput.value = 'コーヒー' + set + '個(' + codes.join('/') + ')';
        }
        setStatus('合計' + set + '個ぴったり！', true);
        setHint(parts.join(' / '));
        setValid(true);
      } else {
        propInput.value = '';
        if (shippingLabelInput) shippingLabelInput.value = '';
        var diff = bags - t;
        if (diff > 0) {
          setStatus('あと ' + diff + ' 袋 選んでください', false);
        } else {
          setStatus(Math.abs(diff) + ' 袋 多いです', false);
        }
        setHint('');
        setValid(false);
      }
    }

    area.querySelectorAll('[data-flavor]').forEach(function (row) {
      var f = row.getAttribute('data-flavor');
      row.querySelector('[data-inc]').addEventListener('click', function () {
        if (total() < bags) { counts[f]++; render(); }
      });
      row.querySelector('[data-dec]').addEventListener('click', function () {
        if (counts[f] > 0) { counts[f]--; render(); }
      });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-htfp]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // クイック追加モーダル等で後から挿入される場合に備える
  document.addEventListener('shopify:section:load', initAll);
})();
